import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import './modal.scss';

type Props = ComponentPropsWithoutRef<typeof Layout>;
export const ModalFixedTopPanel = ({ children, className, ...props }: Props) => (
    <Layout className={cn('modal__fixed-panel', 'modal__fixed-panel--top', className)} {...props}>
        {children}
    </Layout>
);
